import axiosClient from "../../../../api/axiosClient";

// ===============================
// GET USERS
// ===============================
export const fetchUsers = async (token) => {
  axiosClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  const response = await axiosClient.get("/users"); // endpoint API users
  return response.data.data; // pastikan API mengembalikan array user
};


// ===============================
// CREATE
// ===============================
export const createTicket = async (data, token) => {
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${token}`;

  const response = await axiosClient.post("/tickets", data);
  return response.data;
};

// ===============================
// GET DETAIL
// ===============================
export const getTicketById = async (id, token) => {
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${token}`;

  const response = await axiosClient.get(`/tickets/${id}`);
  return response.data;
};

// ===============================
// UPDATE TICKET
// ===============================
export const updateTicket = async (id, data, token) => {
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${token}`;

  const response = await axiosClient.put(`/tickets/${id}`, data);
  return response.data;
};

// ===============================
// UPDATE STATUS PROGRESS
// ===============================
export const updateStatusProgress = async (id, token) => {
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${token}`;

  const response = await axiosClient.put(`updateStatusProgress/${id}`);
  return response.data;
};